import React from "react"
import { CartProvider } from "./src/context/CartContext"

// optional: disable console logs in prod
if (process.env.NODE_ENV !== "development") {
  console.log = () => {}
}

export const wrapRootElement = ({ element }) => {
  return <CartProvider>{element}</CartProvider>
}